<script type="text/jsx">
let svgIcons;
export default {
    name: 'UiIcon',
    functional: true,
    props: {
        for: {
            required: true,
            type: String,
        },
    },
    render(h, { props, data }) {
        if (!svgIcons) {
            // This will create a map of {"svg-name": "contentofsvg"}. The
            // name is generated from the filename by removing the path
            // and extension. This gets used for the `for` attribute.
            //
            // The map is stored in a module scoped variable so it can be shared
            // between instances and cached for faster rendering.
            //
            // Example: to render the icon in `./icons/candidate.svg`, you can
            // use `<icon for="candidate"></icon>`. Note that the path gets
            // removed, so this also works for ./icons/ats/candidate.svg.
            const context = require.context('./icons?raw', true, /.svg$/);
            svgIcons = context.keys().reduce((iconMapping, key) => {
                const filename = key.substring(key.lastIndexOf('/') + 1);
                iconMapping[filename.substring(0, filename.length - 4)] = context(key);

                return iconMapping;
            }, {});
        }

        data.domProps = data.domProps ? data.domProps : {};

        if (Object.keys(svgIcons).includes(props.for)) {
            data.domProps.innerHTML = svgIcons[props.for];
            return <div {...data} class={`icon svg-icon-${props.for}`} role="img" />;
        }

        return <i {...data} role="img" class={`icon icon-${props.for}`} />;
    },
};
</script>
<style lang="scss">
    @import '@/styles/colors/variables';

    .icon {
        fill: currentColor;
        &.green {
            color: $green;
            svg path {
                stroke: $green !important;
                fill: $green !important;
            }
        }
        &.purple {
            color: $purple;
            svg path {
                stroke: $purple !important;
                fill: $purple !important;
            }
        }
        &.white {
            color: $white;
            svg path {
                stroke: $white !important;
                fill: $white !important;
            }
        }
        &.midnight {
            color: $midnight;
            svg path {
                stroke: $midnight !important;
                fill: $midnight !important;
            }
        }
        &.light-gray {
            color: $light-gray;
            svg path {
                stroke: $light-gray !important;
                fill: $light-gray !important;
            }
        }
        &.error {
            color: $alert-error;
            svg path {
                stroke: $alert-error !important;
                fill: $alert-error !important;
            }
        }
        &.success {
            color: $alert-success;
            svg path {
                stroke: $alert-success !important;
                fill: $alert-success !important;
            }
        }
        &.error {
            color: $alert-error;
            svg path {
                stroke: $alert-error !important;
                fill: $alert-error !important;
            }
        }
        &.warn {
            color: $alert-warn;
            svg path {
                stroke: $alert-warn !important;
                fill: $alert-warn !important;
            }
        }
    }
</style>
